module.exports = __webpack_public_path__ + "assets/img/bla3.98f9ee40.png";